import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const undoChangesForPendingFunds = ({ fiduciaryNumber, payload }) => {
  const url = `/pendingfiduciaryfunds/${fiduciaryNumber}/undo`;
  return request.post(url, { data: JSON.stringify(payload) });
};

export const getPendingFundStatusChangesList = async ({ selectedFiduciary, axiosCancelToken }) => {
  const url = `/pendingfiduciaryfunds/${selectedFiduciary}`;
  return request.get(url, {}, axiosCancelToken);
};

export const generateSavePendingFundStatusUrl = ({
  areTargetSeriesFunds,
  allClientsView,
}) => {
  let url = '';
  url = '/pendingfiduciaryfunds';
  if (areTargetSeriesFunds && !allClientsView) {
    url += '?strict_validation=true';
  }

  return url;
};

export const saveToPendingFundStatusChanges = ({
  payload,
  areTargetSeriesFunds,
  allClientsView,
}) => {
  const url = generateSavePendingFundStatusUrl({
    areTargetSeriesFunds,
    allClientsView,
  });
  return request.post(url, { data: JSON.stringify(payload) });
};
